export const ALLOWED_INTEREST_FILTER_FIELDS = new Set([
  'hollandCodesAny',
  'hollandCode1',
  'hollandCode2',
  'hollandCode3',
]);

export function isAllowedInterestFilterField(fieldName: string): boolean {
  if (!fieldName.startsWith('holland')) {
    return true;
  }

  return ALLOWED_INTEREST_FILTER_FIELDS.has(fieldName);
}

export function sanitizeInterestMeasurementFilters<
  T extends Record<string, unknown>
>(filters: T): T {
  return Object.fromEntries(
    Object.entries(filters).filter(([fieldName]) => isAllowedInterestFilterField(fieldName))
  ) as T;
}
